var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWinWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 157 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        mask: url(#mask);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 157,
    height: 40,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_315_1040",
    "data-name": "mask0 315 1040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    className: "cls-1",
    d: "M157,0H0v40h157V0Z"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-win-sm_1",
    "data-name": "logo-win-sm 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip_path_group",
    "data-name": "Clip path group"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-1",
    d: "M147.7,19.6v5.2l3.7-4.2c-1.2-.6-2.4-.9-3.7-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M147.7,26.6v4.7l7.1-8c-.7-.8-1.4-1.6-2.3-2.1l-4.8,5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-1",
    d: "M155.5,24.3l-7.8,8.8v4.7l9.1-10.3c-.2-1.1-.7-2.2-1.3-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-1",
    d: "M147.8,39.5c2.5-.2,4.8-1.3,6.5-3.2,1.7-1.9,2.7-4.3,2.7-6.8,0-.1,0-.3,0-.4l-9.2,10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-1",
    d: "M146.5,19.6c-2.5.1-4.9,1.3-6.6,3.1-1.7,1.9-2.7,4.3-2.7,6.9s1,5,2.7,6.9c1.7,1.9,4.1,3,6.6,3.1v-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-1",
    d: "M57.5.5v24c0,9.4-6.5,15.5-16.4,15.5s-9.6-1.8-12.3-4.9c-2.8,3.1-7,4.9-12.3,4.9C6.5,40,0,33.9,0,24.5V.5h12.1v22.3c0,.7,0,1.4.3,2.1.2.7.6,1.3,1.1,1.8.5.5,1.1.9,1.7,1.1.7.3,1.4.4,2.1.3,3.1,0,5.3-2.1,5.3-5.3V.5h12.1v22.3c0,.7,0,1.4.3,2.1.2.7.6,1.3,1.1,1.8.5.5,1.1.9,1.7,1.1.7.3,1.4.4,2.1.3,3.1,0,5.3-2.1,5.3-5.3V.5h12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    className: "cls-1",
    d: "M80.7.9h-12.1v38.6h12.1V.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "M130.1,14.5v25.1h-12.1v-21c0-4-2.5-6.7-6.4-6.7s-6.9,2.7-6.9,6.8v20.8h-12.1V.9h12.1v3.4c1.5-1.4,3.2-2.5,5.1-3.3C111.7.3,113.7,0,115.7,0,124.3,0,130.1,5.8,130.1,14.5Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWinWhite);
export default __webpack_public_path__ + "static/media/logo-win-white.fa30f59a8af9c7c931d7899ceac9ccff.svg";
export { ForwardRef as ReactComponent };